import axios from 'axios';
import { notification } from 'antd';
import { logout } from 'redux/logout';
import store from 'redux/configureStore';

const apiAxios = axios.create();

const successStatus = (status) => status >= 200 && status < 300;
const isSuccessResponse = (response) => successStatus(response.status);
const errorMessage = (response) =>
  typeof response.data === 'string'
    ? response.data
    : response.data?.message || `Status: ${response.status}`;

apiAxios.defaults.validateStatus = (status) =>
  successStatus(status) ||
  status === 400 ||
  status === 409 ||
  status === 422 ||
  status === 500;

apiAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  },
);

export const updateToken = (token) => {
  apiAxios.defaults.headers.common.authorization = `bearer ${token}`;
};

export const get = (url, options) => apiAxios.get(url, options);

const post = async (url, body, options) => {
  const response = await apiAxios.post(url, body, options);
  if (isSuccessResponse(response)) {
    return response;
  }
  throw new Error(errorMessage(response));
};

const del = (url, body) => apiAxios.delete(url, body);

const put = async (url, body) => {
  const response = await apiAxios.put(url, body);
  if (isSuccessResponse(response)) {
    return response;
  }
  throw new Error(errorMessage(response));
};

export const getData = (url) =>
  new Promise((resolve, reject) => {
    apiAxios
      .get(url)
      .then((result) => {
        const { data, status } = result;
        if (isSuccessResponse(result)) {
          if (data) {
            resolve(data.data);
          } else {
            resolve();
          }
        } else {
          reject(new Error(`Status: ${status}`));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  post,
  get,
  getData,
  put,
  del,
  apiAxios,
  isSuccessResponse,
};
